const loadScript = async (src, options = {}) => {
  if (document.querySelector(`script[src="${src}"]`)) {
    return;
  }

  const script = document.createElement('script');

  script.src = src;

  // set data attributes
  Object.entries(options).forEach(([key, value]) => {
    script.setAttribute(`data-${key}`, value);
  });

  script.defer = true;

  document.head.appendChild(script);

  await new Promise((resolve, reject) => {
    script.onload = resolve;
    script.onerror = reject;
  });
};

// Các công ty đã chuyển sang SDK v2; còn lại vẫn dùng v1.
// const SDK_V2_COMPANY_CODES = ['esbt', 'sota'];

export async function initAISDK() {
  // const isV2 = SDK_V2_COMPANY_CODES.includes(
  //   String(companyCode || '').toLowerCase()
  // );

  // v2 tự xác định api-base, chỉ v1 mới cần truyền.
  const options = { 'app-id': 'AI' };
  // if (!isV2) {
  //   options['api-base'] = 'https://ai.salework.net/ai';
  // }

  try {
    await loadScript(
      `https://ai.salework.net/ai/sdk/v2/salework-ai.js`,
      options
    );
  } catch (error) {
    console.error('initAISDK -> error:', error);
  }
}